import * as Sentry from '@sentry/browser';

export function logError(message: string, error?: unknown): void {
	console.error(message, error);
	if (error instanceof Error) {
		Sentry.captureException(error, { extra: { message } });
	} else {
		Sentry.withScope((scope) => {
			if (error !== undefined) {
				scope.setContext('details', error as Record<string, unknown>);
			}
			Sentry.captureMessage(message, 'error');
		});
	}
}

export function logUserReport(message: string, details: Record<string, unknown>): void {
	Sentry.withScope((scope) => {
		scope.setContext('details', details);
		Sentry.captureMessage(message, 'warning');
	});
}

export function flushLogs(timeoutMs: number): Promise<boolean> {
	return Sentry.flush(timeoutMs);
}
